import yaml from 'js-yaml'
export default yaml.load(`
- name: INLINE at LINE Hack 
  product: LINE Chatbot and Web App
  description: Integration hub for LINE Chat App
  competition: |
    LINE Hackathon Thailand 2016
  awards: "1st Runner-up"
  time: Apr 2016
  role: UX/UI Designer, Frontend Developer
  path: "/works/inline-at-line-hack/"
  thumb: "/works/inline-at-line-hack/inline-preview.jpg"
  cover: "/works/inline-at-line-hack/inline-preview.jpg"
  categories: 
    - mobile 
    - conversational

- name: OSMEP Promotion Project Tracking
  product: Business Intelligence Dashboard
  description: Seeing how well OSMEP's programs are pushing SMEs in Thailand
  client: Thai government's Office of Small and Medium Enterprise Promotion (OSMEP)
  path: "/works/osmep-sme-tracking/"
  role: UX/UI Designer
  time: Apr 2016
  thumb: "/works/osmep-sme-tracking/preview.jpg"
  cover: "/works/osmep-sme-tracking/osmep-sme-tracking-iso-done.jpg"
  categories:
    - webapp

- name: Meditech Senze
  product: Eyetracking Medical Support System
  description: Bringing the web back into ALS patient's life.
  client: Meditech Solution
  role: Interaction Designer, Frontend Developer
  path: "/works/meditech-senze/"
  time: Aug 2015
  thumb: "/works/meditech-senze/meditech-senze-preview.jpg"
  cover: "/works/meditech-senze/meditech-senze-preview.jpg"
  linkLabel: "View Case Study"
  categories: 
    - assistive

- name: OSMEP Business Intelligence
  product: Business Intelligence Dashboard
  description: Interpreting the dataset of 50M+ rows.
  client: Thai government's Office of Small and Medium Enterprise Promotion (OSMEP)
  role: Bussiness Analyst, Designer
  time: Aug 2015
  path: "/works/osmep-business-intelligence/"
  thumb: "/works/osmep-business-intelligence/preview.jpg"
  cover: "/works/osmep-business-intelligence/preview.jpg"
  categories:
    - webapp
    - bigdata

- name: Angie at LINE's Brand Sponsored Hackathon
  product: LINE Chatbot
  description: Acquiring hair conditioner users with a beauty guru chatbot.
  competition: LINE Private Hackathon sponsored by a Brand
  awards: One of the Six Qualified Teams
  time: Jun 2016
  role: UX/UI Designer
  path: "/works/brand-x-line-hack/"
  thumb: "/works/brand-x-line-hack/preview.jpg"
  cover: "/works/brand-x-line-hack/cover.jpg"
  categories:
    - mobile
    - conversational

- name: Microbrik
  product: Web and Mobile App
  description: An online pixel art generator
  client: Uniontoy (Thailand) Co., Ltd.
  path: "/works/microbrik/"
  thumb: "/works/microbrik/preview.jpg"
  role: UX/UI Designer, Developer
  time: May 2015
  site: "http://microbrik.com"
  categories: 
    - webapp
    - mobile

- name: RESUS Ultrasound
  product: iOS Application
  description: Ultrasound bedside reference for mmergency department (ED) physicians 
  client: Dr. Suthaporn Lumlertgul M.D.
  appStoreLink: https://itunes.apple.com/us/app/resus-ultrasound/id1033017112?mt=8&ign-mpt=uo%3D4
  time: Mar 2016
  role: UX Designer, Lead Developer
  path: "/works/resus-ultrasound/"
  thumb: "/works/resus-ultrasound/preview.jpg"
  cover: "/works/resus-ultrasound/cover.jpg"
  categories:
    - mobile

- name: UCheckPoint
  product: Web Application
  description: Helping Thai students do better at exams with machine learning
  client: UCheckPoint
  time: Dec 2015
  role: UX/UI Designer
  path: "/works/ucheckpoint/"
  thumb: "/works/ucheckpoint/preview.jpg"
  cover: "/works/ucheckpoint/cover.jpg"
  categories:
    - webapp

- name: Runnables Branding Kit
  product: Corporate Branding Kit
  role: Designer
  description: Crafting the identify of Runnables
  path: "/works/runnables-branding-kit/"
  time: Dec 2014
  thumb: "/works/runnables-branding-kit/preview.jpg"
  cover: "/works/runnables-branding-kit/runnables-branding-kit-iso.jpg"
  site: "https://runnables.co.th"

- name: Projects at Digimagic
  product: Multiple Projects
  description: My stint as a multimedia developer at Digimagic
  client: Digimagic
  path: "/works/digimagic-projects/"
  thumb: "/works/digimagic-projects/preview.jpg"
  role: Multimedia Developer
  time:  Apr 2012 - Jun 2014
  categories: 
    - mobile
    - webapp
    - "computer-graphics"

- name: Skinspiel
  product: Projection Mapping on Moving Object
  description: A cost-effective alternative for projection mapping on moving objects
  time: Jan 2012
  for: Computer Engineering Senior Project
  role: Undergrad Student
  path: "/works/skinspiel/"
  thumb: "/works/skinspiel/preview.jpg"
  categories:
    - "computer-graphics"

- name: Mobile Reality Boxing
  product: Android AR Boxing Game
  competition: NECTEC's National Software Contest
  awards: Top 10 Finalists
  time: Dec 2011
  role: Undergrad Student
  description: A mobile boxing game mimicking actual physical interactions
  path: "/works/mobile-reality-boxing/"
  thumb: "/works/mobile-reality-boxing/preview.jpg"
  cover: "/works/mobile-reality-boxing/preview.jpg"
  categories: 
    - mobile
    - "computer-graphics"

`)


/** WEBPACK FOOTER **
 ** ../data/works.js
 **/